export enum PaidAccountErrorExtensions {
  FAILED_TO_CONFIRM = 'FAILED_TO_CONFIRM',
  USER_UNCONFIRMED = 'USER_UNCONFIRMED',
  LEGAL_INVALID_CONTACT_NAME = 'LEGAL_INVALID_CONTACT_NAME',
  LEGAL_INVALID_CONTACT_EMAIL = 'LEGAL_INVALID_CONTACT_EMAIL',
  LEGAL_INVALID_CONTACT_LOCALE = 'LEGAL_INVALID_CONTACT_LOCALE',
  LEGAL_INVALID_TOS = 'LEGAL_INVALID_TOS',
  PAYMENT_CARD_INVALID = 'PAYMENT_CARD_INVALID',
  PAYMENT_CARD_DECLINED = 'PAYMENT_CARD_DECLINED',
  PROMO_CODE_INVALID = 'PROMO_CODE_INVALID',
  PROMO_CODE_EXPIRED = 'PROMO_CODE_EXPIRED',
  PROMO_CODE_ALREADY_REDEEMED = 'PROMO_CODE_ALREADY_REDEEMED',
  SHOP_UNSUPPORTED_CARD_TYPE = 'SHOP_UNSUPPORTED_CARD_TYPE',
  SHOP_INVALID_TAX_COUNTRY_CODE = 'SHOP_INVALID_TAX_COUNTRY_CODE',
  SHOP_INVALID_TAX_ZIP_CODE = 'SHOP_INVALID_TAX_ZIP_CODE',
  SHOP_INVALID_TAX_ID = 'SHOP_INVALID_TAX_ID',
}

export const PaidAccountErrors: Record<string, PaidAccountErrorExtensions> = {
  'invalid email address':
    PaidAccountErrorExtensions.LEGAL_INVALID_CONTACT_EMAIL,
  'invalid value for country':
    PaidAccountErrorExtensions.SHOP_INVALID_TAX_COUNTRY_CODE,
  'invalid value for zipCode':
    PaidAccountErrorExtensions.SHOP_INVALID_TAX_ZIP_CODE,
  'invalid value for taxId': PaidAccountErrorExtensions.SHOP_INVALID_TAX_ID,
  'invalid value for billingContactFullName':
    PaidAccountErrorExtensions.LEGAL_INVALID_CONTACT_NAME,
  'invalid value for billingContactEmail':
    PaidAccountErrorExtensions.LEGAL_INVALID_CONTACT_EMAIL,
  'invalid value for billingContactLocale':
    PaidAccountErrorExtensions.LEGAL_INVALID_CONTACT_LOCALE,
  'invalid value for acceptTOS': PaidAccountErrorExtensions.LEGAL_INVALID_TOS,
  'U.S. addresses require a 5 or 9 digit zip code':
    PaidAccountErrorExtensions.SHOP_INVALID_TAX_ZIP_CODE,
  'must accept terms of service': PaidAccountErrorExtensions.LEGAL_INVALID_TOS,
  'needs a credit card nonce': PaidAccountErrorExtensions.PAYMENT_CARD_INVALID,
  'need to verify account': PaidAccountErrorExtensions.USER_UNCONFIRMED,
  'card was declined': PaidAccountErrorExtensions.PAYMENT_CARD_DECLINED,
  'Code not found': PaidAccountErrorExtensions.PROMO_CODE_INVALID,
  'this code does not apply to this billing period':
    PaidAccountErrorExtensions.PROMO_CODE_INVALID,
  'Your code is invalid': PaidAccountErrorExtensions.PROMO_CODE_INVALID,
  'Code was already used':
    PaidAccountErrorExtensions.PROMO_CODE_ALREADY_REDEEMED,
  'Code has expired': PaidAccountErrorExtensions.PROMO_CODE_EXPIRED,
};
